import { VuexModule, Module, Action, getModule } from "vuex-module-decorators";
import store from "@/store";
import auth from "@/store/modules/auth";
import { db } from "@/main";
import { firestore } from 'firebase';

@Module({
  namespaced: true,
  name: "user",
  dynamic: true,
  store
})
class UserModule extends VuexModule {

  @Action
  async addAppToken(token: string) {
    if (!auth.user) return;
    await db.collection("users").doc(auth.user.uid).set({ "notificationTokens": firestore.FieldValue.arrayUnion(token)}, { merge: true });
  }
}

export default getModule(UserModule);